/** One transcription run (Spec § 3.3): `PENDING → READY | FAILED`. */
export var TranscriptStatus;
(function (TranscriptStatus) {
    TranscriptStatus["PENDING"] = "PENDING";
    TranscriptStatus["READY"] = "READY";
    TranscriptStatus["FAILED"] = "FAILED";
})(TranscriptStatus || (TranscriptStatus = {}));
//# sourceMappingURL=transcript-status.enum.js.map